import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import ClockIcon from '../icons/ClockIcon';
import { USER_AVAILABILITY } from '../config';

import sectionCss from './AvailabilitySection.css';
import css from '../ProfileSettingsForm.css';
import { LoopIcon, WarningIcon } from '../../../icons';
import classNames from 'classnames';
import ScoreBadge from '../../../components/ScoreBadge/ScoreBadge';
import { Button, IconSpinner } from '../../../components';
import { RIDER_AVAILABILITY_NOT_AVAILABLE } from '../../../marketplace-custom-config';

const AvailabilitySection = ({
    availability,
    openForPartTimeProposals,
    renderEditPencilIcon,
    isPublic,
    handleEditSection,
    scoreData,
    scoreReqInProgress,
    displayName,
    isLoggedOut,
}) => {
    const noData = !availability;

    if (isPublic && noData && !isLoggedOut) {
        return (
            <div className={css.infoBlock}>
                <h2 className={css.infoHeading}>Verfügbarkeit</h2>
                <p className={css.noData}>
                    {displayName} hat noch keine Verfügbarkeit hinzugefügt.
                </p>
            </div>
        );
    }

    if (isPublic && noData) return null;

    return (
        <div className={css.infoBlock}>
            {scoreData && scoreData.baseScoreBreakdown && (
                <ScoreBadge scoreData={scoreData.baseScoreBreakdown?.availabilityScore} />
            )}
            {scoreReqInProgress && <IconSpinner />}
            <h2 className={css.infoHeading}>
                <span>Verfügbarkeit</span>
                {noData ? (
                    <WarningIcon rootClassName={css.noInfoWarningIcon} />
                ) : (
                    <div className={css.editBlock}>{renderEditPencilIcon(USER_AVAILABILITY)}</div>
                )}
            </h2>
            {noData ? (
                <Button
                    type="button"
                    onClick={() => {
                        handleEditSection(USER_AVAILABILITY);
                    }}
                    className={`${css.actionItem} ${css.actionBtn}`}
                >
                    Verfügbarkeit hinzufügen
                </Button>
            ) : (
                <p className={sectionCss.availabilityItem}>
                    <ClockIcon />
                    {availability === 'flexible' ? (
                        <FormattedMessage id="CollectUserInfoWizard.availabilityFlexibleOption" />
                    ) : availability === RIDER_AVAILABILITY_NOT_AVAILABLE ? (
                        <FormattedMessage id="CollectUserInfoWizard.notAvailable" />
                    ) : (
                        <FormattedMessage
                            id="ProfileSettingsForm.availabilityPerWeek"
                            values={{ availability }}
                        />
                    )}
                </p>
            )}
            {!noData && openForPartTimeProposals && (
                <p
                    className={classNames([
                        sectionCss.availabilityItem,
                        sectionCss.availabilityItemProposal,
                    ])}
                >
                    <LoopIcon />
                    <FormattedMessage
                        id={`ProfileSettingsForm.openForPartTimeProposals-${openForPartTimeProposals}${
                            isPublic ? '-public' : ''
                        }`}
                    />
                </p>
            )}
        </div>
    );
};

export default AvailabilitySection;
